import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import AllUsersProfileReportTable from './AllUsersProfileReportTable'

const AllUsersProfileReport = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <AllUsersProfileReportTable/>
                </div>
            </div>
        </>
    );
}

export default AllUsersProfileReport;